import React, { useEffect, useState } from 'react';
import { auth } from '../config/firebase';
import { useNavigate } from 'react-router-dom';
import Chat from './Chat';
import { getSpotifyAuthUrl, getValidSpotifyToken } from '../utils/spotify-auth';

export default function Dashboard() {
  const navigate = useNavigate();
  const [spotifyProfile, setSpotifyProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSpotifyConnection = async () => {
      if (!auth.currentUser) return;

      try {
        
        const accessToken = await getValidSpotifyToken();
        
        const response = await fetch('https://api.spotify.com/v1/me', {
          headers: {
            'Authorization': `Bearer ${accessToken}`
          }
        });

        if (response.ok) {
          const profile = await response.json();
          setSpotifyProfile(profile);
        }
      } catch (error) {
        console.error('Error fetching Spotify profile:', error);
      } finally {
        setLoading(false);
      }
    };

    checkSpotifyConnection();
  }, []);

  const handleSpotifyLogin = () => {
    window.location.href = getSpotifyAuthUrl();
  };

  const handleLogout = () => {
    auth.signOut();
    navigate('/');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="bg-white p-8 rounded-lg shadow-md">
          <h1 className="text-2xl font-bold mb-6">Dashboard</h1>
          
          <div className="mb-6 p-4 bg-gray-50 rounded-lg">
            <h2 className="text-lg font-semibold mb-2">Google Account</h2>
            <p className="text-gray-600">Email: {auth.currentUser?.email}</p>
            <p className="text-gray-600">Name: {auth.currentUser?.displayName}</p>
            {auth.currentUser?.photoURL && (
              <img 
                src={auth.currentUser.photoURL} 
                alt="Profile" 
                className="w-10 h-10 rounded-full mt-2"
              />
            )}
          </div>
  
          <div className="mb-6 p-4 bg-gray-50 rounded-lg">
            <h2 className="text-lg font-semibold mb-2">Spotify Account</h2>
            {spotifyProfile ? (
              <>
                <p className="text-gray-600">Username: {spotifyProfile.display_name}</p>
                <p className="text-gray-600">Email: {spotifyProfile.email}</p>
                {/* {spotifyProfile.images?.[0]?.url && (
                  <img 
                    src={spotifyProfile.images[0].url} 
                    alt="Spotify Profile" 
                    className="w-10 h-10 rounded-full mt-2"
                  />
                )} */}
                {/* <p className="text-green-600 mt-2">✓ Connected</p> */}
              </>
            ) : (
              <button
                onClick={handleSpotifyLogin}
                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 w-full"
              >
                Connect Spotify
              </button>
            )}
          </div>
  
          <button
            onClick={handleLogout}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 w-full"
          >
            Logout
          </button>
        </div>
  
        <Chat spotifyProfile={spotifyProfile}/>
      </div>
    </div>
  );
}